import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft, Eye } from 'lucide-react'
import Dashboard from '../Dashboard'

/**
 * A read-only-in-intent layout preview of the client dashboard, reached
 * only from the admin account's own account menu (/admin/client-view,
 * behind AdminProtectedRoute). It renders the real <Dashboard /> under
 * Cassie's own authenticated admin session — never a real client's account
 * — so there is nothing to impersonate and no client permission is
 * bypassed: she sees exactly what her own account can see, which is the
 * same component a client sees, just with her own (empty) data. It exists
 * purely so she can check the client-facing layout without repeatedly
 * signing out and back in with a separate test account.
 */
const AdminClientPreview: React.FC = () => {
  const navigate = useNavigate()

  return (
    <div>
      <div className="sticky top-0 z-40 bg-ink text-white">
        <div className="container-max px-4 sm:px-6 lg:px-8 py-2.5 flex items-center justify-between gap-3 flex-wrap">
          <span className="flex items-center gap-2 text-xs sm:text-sm font-medium text-white/90">
            <Eye size={14} className="shrink-0" />
            Admin preview — this is the client dashboard layout, viewed from your own admin account. Not a real
            client, and no client data is shown.
          </span>
          <button
            onClick={() => navigate('/admin/dashboard')}
            className="inline-flex items-center gap-1.5 text-xs sm:text-sm font-semibold text-gold-light hover:text-gold transition-colors shrink-0"
          >
            <ArrowLeft size={14} />
            Back to Admin Dashboard
          </button>
        </div>
      </div>
      <Dashboard />
    </div>
  )
}

export default AdminClientPreview
